import { render, staticRenderFns } from "./TheCapture.vue?vue&type=template&id=249d87b4&scoped=true&"
import script from "./TheCapture.vue?vue&type=script&lang=js&"
export * from "./TheCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d87b4",
  null
  
)

export default component.exports